import { Routes } from '@angular/router';
import {FormsBuilderIndexComponent} from './index.component';
import {FormsBuilderEditComponent} from './edit.component';
import {LoginComponent} from './login/login.component';

export const routes: Routes = [
  { path: '', redirectTo: '/forms', pathMatch: 'full' },
  { path: 'forms', redirectTo: '/forms/builder', pathMatch: 'full' },
  { path: 'forms/builder', redirectTo: '/forms/builder/index', pathMatch: 'full' },
  {
    path: "forms/builder/index",
    component: FormsBuilderIndexComponent
  },
  {
    path: "forms/builder/edit/:formId",
    component: FormsBuilderEditComponent
  },
  {path: 'login', component: LoginComponent},
  {path: 'logout', component: LoginComponent, data: {logout: true}},
];
